export default "__VITE_ASSET__BLxRhsOX__"